import { Scroll, Stack } from '@/components/layout';
import { StackLayoutProps } from '@/components/layout/stack/types';
import { useDailyBackground } from '@/hooks';
import { ImageBackground, ImageStyle, Platform, StyleSheet } from 'react-native';

export const DashboardContainerRoot = ({ children, ...props }: StackLayoutProps) => {
  return (
    <Stack flex={1}>
      <Scroll bounces={false} flexGrow={1} showsVerticalScrollIndicator={false} {...props}>
        <Stack flex={1} width="100%" align="center">
          {children}
        </Stack>
      </Scroll>
    </Stack>
  );
};

export const DashboardBackground = () => {
  const backgroundSource = useDailyBackground();
  return (
    <ImageBackground
      style={styles.background}
      imageStyle={Platform.OS === 'web' ? webBackgroundFill : undefined}
      resizeMode="cover"
      source={backgroundSource}
    />
  );
};

/** RN `DimensionValue` typings omit CSS units; `react-native-web` accepts them at runtime. */
const webBackgroundFill = {
  width: '100%',
  height: '100vh',
} as unknown as ImageStyle;

const styles = StyleSheet.create({
  background: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
});
